const testimonials = [
  {
    name: 'Dr. Ricardo Almeida',
    role: 'Advogado Trabalhista — São Paulo/SP',
    text: 'A Exato Cálculos transformou a forma como meu escritório lida com liquidações. A precisão é impressionante e o tempo de entrega caiu pela metade.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Brazilian%20male%20lawyer%20headshot%2C%20confident%20smile%2C%20suit%20and%20tie%2C%20clean%20white%20background%2C%20corporate%20portrait%20photography%2C%20high%20quality&width=80&height=80&seq=av001&orientation=squarish',
  },
  {
    name: 'Dra. Fernanda Souza',
    role: 'Perita Judicial — Rio de Janeiro/RJ',
    text: 'Nunca vi uma ferramenta tão completa para cálculos trabalhistas. A IA deles é realmente diferente — os resultados são consistentes e tecnicamente impecáveis.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Brazilian%20female%20lawyer%20headshot%2C%20confident%20smile%2C%20formal%20attire%2C%20clean%20white%20background%2C%20corporate%20portrait%20photography%2C%20high%20quality&width=80&height=80&seq=av002&orientation=squarish',
  },
  {
    name: 'Dr. Marcos Oliveira',
    role: 'Sócio — Oliveira & Associados, Curitiba/PR',
    text: 'Contratamos a Exato para nosso escritório e o retorno foi imediato. Escalamos nossa capacidade de atendimento sem precisar contratar mais peritos.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Brazilian%20male%20senior%20lawyer%20headshot%2C%20glasses%2C%20confident%20expression%2C%20suit%2C%20clean%20white%20background%2C%20corporate%20portrait%20photography%2C%20high%20quality&width=80&height=80&seq=av003&orientation=squarish',
  },
];

const stats = [
  { value: '100K+', label: 'Cálculos entregues' },
  { value: '19', label: 'Anos no mercado' },
  { value: '500+', label: 'Clientes ativos' },
  { value: '99.8%', label: 'Taxa de precisão' },
];

export default function ProvasSocial() {
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {stats.map((s) => (
            <div key={s.label} className="text-center p-6 rounded-2xl border border-gray-100 bg-gray-50">
              <div className="text-4xl font-bold text-gray-900 mb-1">{s.value}</div>
              <div className="text-sm text-gray-500">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold tracking-widest uppercase text-sky-500 mb-4">Depoimentos</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            O que dizem os profissionais
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.name} className="p-7 rounded-2xl border border-gray-100 bg-gray-50 flex flex-col gap-5">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed flex-1">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full overflow-hidden shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <div className="text-sm font-bold text-gray-800">{t.name}</div>
                  <div className="text-xs text-gray-400">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Partners */}
        <div className="mt-20 text-center">
          <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-8">Parceiros de Confiança</p>
          <div className="flex items-center justify-center gap-10 flex-wrap">
            {[1, 2, 3].map((n) => (
              <div key={n} className="flex items-center justify-center h-14">
                <img
                  src={`https://portal.exatocalculos.com.br/img/case/${n}.png`}
                  alt={`Parceiro ${n}`}
                  className="h-16 object-contain grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
